import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { Button } from '../ui/button';
import { useLanguage } from '../../context/LanguageContext';

const Services = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 bg-neutral-950 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-red-600/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl" />

      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="text-center mb-16">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider">{t('services.badge')}</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mt-4">{t('services.title')}</h2>
          <p className="text-neutral-400 mt-4 max-w-2xl mx-auto">{t('services.subtitle')}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* Service 1 - 3D Concrete */}
          <div className="group relative bg-neutral-900/50 backdrop-blur-sm rounded-3xl overflow-hidden border border-neutral-800 hover:border-red-500/50 transition-all duration-500 hover:scale-[1.02]">
            <div className="relative h-64 overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_modular-expert/artifacts/ac8vgd9y_IMG_2138.JPG" 
                alt="Impresión 3D de Hormigón" 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/50 to-transparent" />
              <div className="absolute top-4 right-4 bg-red-600 text-white text-sm font-semibold px-4 py-2 rounded-full">
                {t('services.concrete.price')}
              </div>
            </div>
            <div className="p-8">
              <span className="text-red-400 text-sm font-medium">{t('services.concrete.badge')}</span>
              <h3 className="text-2xl font-bold text-white mt-2 mb-4">{t('services.concrete.title')}</h3>
              <p className="text-neutral-400 mb-6">{t('services.concrete.description')}</p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3 text-neutral-300">
                  <div className="w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center">
                    <Check size={12} className="text-red-400" />
                  </div>
                  {t('services.concrete.feature1')}
                </li>
                <li className="flex items-center gap-3 text-neutral-300">
                  <div className="w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center">
                    <Check size={12} className="text-red-400" />
                  </div>
                  {t('services.concrete.feature2')}
                </li>
                <li className="flex items-center gap-3 text-neutral-300">
                  <div className="w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center">
                    <Check size={12} className="text-red-400" />
                  </div>
                  {t('services.concrete.feature3')}
                </li>
              </ul>
              <Button className="w-full bg-white/10 hover:bg-red-600 text-white border border-white/20 hover:border-red-600 transition-all duration-300" asChild>
                <Link to="/3d-concrete-printing">{t('services.viewMore')} <ArrowRight className="ml-2" size={18} /></Link>
              </Button>
            </div>
          </div>

          {/* Service 2 - Modular */}
          <div className="group relative bg-neutral-900/50 backdrop-blur-sm rounded-3xl overflow-hidden border border-neutral-800 hover:border-red-500/50 transition-all duration-500 hover:scale-[1.02]">
            <div className="relative h-64 overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1653271827655-090279078f29?w=800&auto=format&fit=crop" 
                alt="Unidades Modulares" 
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" 
              />
              <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/50 to-transparent" />
              <div className="absolute top-4 right-4 bg-red-600 text-white text-sm font-semibold px-4 py-2 rounded-full">
                {t('services.modular.price')}
              </div>
            </div>
            <div className="p-8">
              <span className="text-red-400 text-sm font-medium">{t('services.modular.badge')}</span>
              <h3 className="text-2xl font-bold text-white mt-2 mb-4">{t('services.modular.title')}</h3>
              <p className="text-neutral-400 mb-6">{t('services.modular.description')}</p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3 text-neutral-300">
                  <div className="w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center">
                    <Check size={12} className="text-red-400" />
                  </div>
                  {t('services.modular.feature1')}
                </li>
                <li className="flex items-center gap-3 text-neutral-300">
                  <div className="w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center">
                    <Check size={12} className="text-red-400" />
                  </div>
                  {t('services.modular.feature2')}
                </li>
                <li className="flex items-center gap-3 text-neutral-300">
                  <div className="w-5 h-5 rounded-full bg-red-500/20 flex items-center justify-center">
                    <Check size={12} className="text-red-400" />
                  </div>
                  {t('services.modular.feature3')}
                </li>
              </ul>
              <Button className="w-full bg-white/10 hover:bg-red-600 text-white border border-white/20 hover:border-red-600 transition-all duration-300" asChild>
                <Link to="/modular-platform">{t('services.viewMore')} <ArrowRight className="ml-2" size={18} /></Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
